import React from "react"

import {Card} from "@components/index"

export function GroupStats() {


    return <Card
        title="Group Game Play Stats"
    >
        Group game play stats placeholder
    </Card>
}